<template lang="html">
  <div class="card typo-sans">
    <div class="card__headline">
      {{ headline }}
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div class="card__paragraph" v-html="paragraph_html" />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['links']),
    headline() {
      return this.$options.filters.t('client.fused.job.expired.headline')
    },
    paragraph_html() {
      const jobsLink = `<a href="${
        this.links.jobsEmptyProfile
      }" class="card__link">${this.$options.filters.t(
        'client.fused.job.expired.jobs_link_text'
      )}</a>`

      if (this.isUserLoggedIn()) {
        return this.$options.filters.t(
          'client.fused.job.expired.paragraph_html',
          {
            jobs_link: jobsLink
          }
        )
      } else {
        const registrationLink = `<a href="${
          this.links.registration
        }" class="card__link">${this.$options.filters.t(
          'client.fused.job.expired.register_link_text'
        )}</a>`

        return this.$options.filters.t(
          'client.fused.job.expired.paragraph_register_html',
          {
            jobs_link: jobsLink,
            register_link: registrationLink
          }
        )
      }
    }
  },
  methods: {
    ...mapGetters(['isUserLoggedIn'])
  }
}
</script>
